import api from 'api';

export const loadEvent = api('GET /api/events/:id');
export const loadEventDetails = api('GET /api/events/:id/details');

export const createEvent = api('POST /api/events');
export const editEvent = api('PUT /api/events');
export const validateEvent = api('POST /api/events/validate');
export const exportEvents = api('POST /api/events/export', {
  responseType: 'blob',
});
export const sendToAppsFlyer = api('POST /api/events/send-to-apps-flyer');
